import { useUserStore } from '@Auth/store';
import { queryOptions, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import type { Team } from '../../@types/types';
import { getRequestAuthPayload } from '../helpers/getRequestAuth';

import type { QueryFactory } from './factory.types';

const fetchTeams = async (shouldShowAllTeams = false): Promise<Team[]> => {
  const params = shouldShowAllTeams === true ? { type: 'template' } : null;
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: '/teams',
    params,
  });

  const response = await axios(networkPayload);
  return response.data;
};

export const fetchAllTeams = async () => await fetchTeams(true);
export const fetchUserTeams = async () => await fetchTeams(false);

export const teamQueries = {
  list: () =>
    queryOptions({
      queryKey: ['allTeams'] as const,
      queryFn: fetchAllTeams,
    }),
  forUser: (tenantIds: number[] = []) =>
    queryOptions({
      queryKey: ['userTeams', ...tenantIds] as const,
      queryFn: fetchUserTeams,
    }),
} satisfies QueryFactory;

export function useAllTeams() {
  return useQuery(teamQueries.list());
}

export function useTeamsForUser() {
  const tenantIds = useUserStore((s) => s.user?.tenantIds ?? []);
  return useQuery(teamQueries.forUser(tenantIds));
}
